import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { contactsOrderBy } from '@epi-constants/contactsOrderBy';
import { REHYDRATE } from 'redux-persist/constants';
import { CompanyInfoState, ContactsOrder } from './companyInfo.selectors';

const initialState = {
  contactsOrder: {
    sortingBy: contactsOrderBy.Active,
    ascending: true
  },
  editMode: false,
  showSlideout: false,
  slideoutEditMode: false
};

const rehydrateAction = createAction<{ companyInfo: CompanyInfoState }, string>(
  REHYDRATE
);

const companyInfoSlice = createSlice({
  name: 'companyInfo',
  initialState,
  reducers: {
    setContactsOrder: (
      state: CompanyInfoState,
      { payload: { sortingBy, ascending } }: PayloadAction<ContactsOrder>
    ) => {
      return {
        ...state,
        contactsOrder: { sortingBy, ascending }
      };
    },
    openSlideout: (state: CompanyInfoState) => ({
      ...state,
      showSlideout: true
    }),
    closeSlideout: (state: CompanyInfoState) => ({
      ...state,
      showSlideout: false
    }),
    enableSlideoutEditMode: (state: CompanyInfoState) => ({
      ...state,
      slideoutEditMode: true
    }),
    disableSlideoutEditMode: (state: CompanyInfoState) => ({
      ...state,
      slideoutEditMode: false
    }),
    enableEditMode: (state: CompanyInfoState) => ({
      ...state,
      editMode: true
    }),
    disableEditMode: (state: CompanyInfoState) => ({
      ...state,
      editMode: false
    })
  },
  extraReducers: builder => {
    builder.addCase(rehydrateAction, (state: CompanyInfoState, action) => {
      if (action.type === REHYDRATE && action.payload.companyInfo) {
        return {
          ...action.payload.companyInfo,
          rehydrated: true
        };
      }
      return state;
    });
  }
});

export const { reducer, actions: companyInfoSliceActions } = companyInfoSlice;
